import type { TFunction } from 'i18next'
import type { AppPage } from './appRoutes'

const withBrand = (title: string, brand: string) => `${title} - ${brand}`

export const getFallbackPageTitle = (page: AppPage, t: TFunction): string => {
  const brand = t('common:brand')

  switch (page) {
    case 'home':
      return t('common:meta.title')
    case 'pinyin-module':
      return withBrand(t('navigation:pinyinSubmenu.pinyinModule'), brand)
    case 'pinyin-learning':
      return withBrand(t('navigation:pinyinSubmenu.pinyinLearning'), brand)
    case 'tone-learning':
      return withBrand(t('navigation:pinyinSubmenu.toneLearning'), brand)
    case 'pinyin-table':
      return withBrand(t('navigation:pinyinSubmenu.pinyinTable'), brand)
    case 'pinyin-index':
      return withBrand(t('navigation:pinyinSubmenu.pinyinChart'), brand)
    case 'resources-download':
      return withBrand(t('pages:resources.title'), brand)
    case 'product-info':
      return withBrand(t('pages:productInfo.title'), brand)
    case 'terms':
      return withBrand(t('pages:terms.title'), brand)
    case 'privacy':
      return withBrand(t('pages:privacy.title'), brand)
    case 'contact':
      return withBrand(t('pages:contact.title'), brand)
    case 'chengyu-learning':
      return withBrand(t('chengyu:learning.title'), brand)
    case 'chengyu-stage':
    case 'chengyu-idiom':
      return withBrand(t('navigation:nav.idiomLearning'), brand)
    case 'chengyu-flashcards':
      return withBrand(t('chengyu:flashcards.title'), brand)
    case 'chengyu-dictionary':
      return withBrand(t('pages:dictionary.title'), brand)
    case 'chengyu-games':
      return withBrand(t('pages:games.home.title'), brand)
    case 'chengyu-game-puzzle':
      return withBrand(t('pages:games.puzzle.title'), brand)
    case 'chengyu-game-fill':
      return withBrand(t('pages:games.fill.title'), brand)
    case 'chengyu-game-solitaire':
      return withBrand(t('pages:games.solitaire.title'), brand)
    case 'character-free':
      return withBrand(t('navigation:characterSubmenu.freeLearn'), brand)
    case 'character-recognize':
    case 'character-recognize-level':
      return withBrand(t('navigation:characterSubmenu.recognize'), brand)
    case 'character-recognize-detail':
      return withBrand(t('navigation:nav.characterLearning'), brand)
    case 'character-handwrite':
    case 'character-handwrite-level':
    case 'character-handwrite-detail':
      return withBrand(t('pages:character.handwritingTitle'), brand)
    case 'character-goal':
      return withBrand(t('pages:character.goalTitle'), brand)
    case 'character-goal-learn':
      return withBrand(t('pages:character.dailyLearningTitle'), brand)
    case 'character-goal-review':
      return withBrand(t('pages:character.dailyReviewTitle'), brand)
    case 'vocabulary-book':
      return withBrand(t('pages:character.vocabularyBookTitle'), brand)
    case 'learned-words':
      return withBrand(t('pages:character.learnedWordsTitle'), brand)
    case 'mastered-words':
      return withBrand(t('pages:character.masteredWordsTitle'), brand)
    default:
      return t('common:meta.title')
  }
}
